import React, { useContext } from 'react'
import { Box, Typography } from '@mui/material'

import { ScreenContext } from 'apps/utils/ScreenContext'
import Wrapper from 'apps/common/Wrapper'

import { useStyles } from './styles'

// Shared shell for ACT-style section pages (TEAM, AI, OPEN): a 185px
// rotated rail label on the left, and a content column matching TECH's
// fixed width (1085px, 104px right margin) so every page lines up exactly.
const SectionShell = ( { railLabel, children } ) => {
	const classes = useStyles()
	const { isLaptop } = useContext( ScreenContext )

	return (
		<Wrapper footerNavClassName={ classes.footerNav }>
			<Box display='grid' gridTemplateColumns={ isLaptop ? '185px auto' : 'auto' }>
				{ isLaptop &&
					<Box
						width='185px'
						borderRight='1px solid var(--line)'
						textTransform='uppercase'
						paddingTop='127px'
						display='flex'
						justifyContent='center'
						alignItems='flex-start'
						sx={{
							// Clip horizontal overflow only — a wide rotated
							// label (10vw) can be a few px wider than the rail
							// itself. Vertical overflow must stay visible:
							// content-light pages (AI) give this row a short
							// grid height, and clipping that axis would cut
							// long single-word labels off mid-word.
							overflowX: 'hidden',
							overflowY: 'visible'
						}}
					>
						<Typography
							fontSize='10vw'
							fontWeight='bold'
							color='var(--ink)'
							sx={{
								writingMode: 'tb',
								transform: 'scale(-1)',
								textTransform: 'uppercase',
								whiteSpace: 'nowrap'
							}}
						>
							{ railLabel }
						</Typography>
					</Box>
				}
				<Box
					maxWidth={ isLaptop ? '1085px' : '100%' }
					marginRight={ isLaptop ? '104px' : '0' }
					borderRight='1px solid var(--line)'
				>
					{ children }
				</Box>
			</Box>
		</Wrapper>
	)
}

export default SectionShell
